<template>
  <div class="tablero-flex">
    <DaiBoxPlot
      :caja_id="'boxplot1'" 
      :datos="datos_boxplot"
      :variables="{'grupos':'Edad_rango','variable_dist':'CD4_A','color':'#B70BFF'}"
      :ancho_tooltip="200"
      :margen="margenes_boxplot"
      :alto_vis="alto_vis_barras_apiladas *1.1"
      :textoTooltip="textoTooltipBoxPlotLinfoEdad"
      :titulo_eje_x="'Rango de edades'"
      :titulo_eje_y="'Conteo de células T CD4+'"
      ref='cajas-linfocitos'
      class="contenedor-barras-apiladas-elaboradas flex-1 ajuste-radius-boxplot"
      :reticula="true"
    >
      <template slot="encabezado">
        	<h5 class="titulo-visualizacion">Conteo de linfocitos con respecto a edad</h5>
        	<p class="fecha-actualizacion" >{{fecha_actualizacion}}</p>
			<button type="button" class="boton-modal " @click="$refs.modal_boxplot_linfocitos.abrirModal()">
				Acerca de la gráfica
			</button>
			<modal ref="modal_boxplot_linfocitos" :posicion_boton="'arriba'">
				<template v-slot:cuerpo>
				<p>La siguiente gráfica muestra la distribución de conteo de linfocitos T CD4+ de todas las personas que participan en el estudio, por rango de edad. El conteo de linfocitos T CD4+ nos indica el estado del sistema inmune en el momento en que las personas se integran al estudio, el cual muchas veces coincide con su incorporación al seguimiento clínico. Valores por debajo de 200 células/microlitro de sangre indican una infección por VIH avanzada, definida como síndrome de inmunodeficiencia adquirida (SIDA).</p>
				</template>
			</modal>
        <div class="encabezado-leyenda">
          <h5 class="titulo-leyenda">Nivel de linfocitos</h5>
          <div class="flex-leyenda">
            <div class="cuadro-leyenda color-1"></div>
            <p class="texto-leyenda">Bajo</p>
            <BotonInfoTooltip contenido="<p><b>Bajo</b> (&lt;=200)</p><p><b>Enfermedad avanzada, etapa de SIDA</b> Mayor aumento de riesgo</p>"/>
            <div class="cuadro-leyenda color-2"></div>
            <p class="texto-leyenda">Intermedio</p>
            <BotonInfoTooltip contenido="<p><b>Intermedio</b> (201-500)</p><p><b>Sistema inmune debilitado</b> Riesgo de avance a SIDA</p>" />
            <div class="cuadro-leyenda color-3"></div>
            <p class="texto-leyenda">Normal</p>
            <BotonInfoTooltip contenido="<p><b>Normal</b> (&gt;501)</p><p>Nivel de linfocitos en una persona no infectada o bajo tratamiento antiretroviral exitoso.</p>" />
          </div>
          <img class="svg-leyenda" src="@/assets/img/boxplot/boxplot-info.svg" alt="">
        </div>
      </template>
      <template slot="pie">
        <div class="pie-leyenda">
          <h5 class="titulo-leyenda">Nivel de linfocitos</h5>
          <div class="flex-leyenda">
            <div class="cuadro-leyenda color-1"></div>
            <p class="texto-leyenda">Bajo</p>
            <div class="cuadro-leyenda color-2"></div>
            <p class="texto-leyenda">Intermedio</p>
            <div class="cuadro-leyenda color-3"></div>
            <p class="texto-leyenda">Normal</p>
          </div>
          <div class="texto-leyenda-notas">
            <p>
              <b>Bajo</b> (&lt;=200)<br>
              <b>Enfermedad avanzada, etapa de SIDA</b> Mayor aumento de riesgo
            </p>
            <p>
              <b>Intermedio</b> ((201-500)<br>
              <b>Sistema inmune debilitado</b> Riesgo de avance a SIDA
            </p>
            <p>
              <b>Normal</b> (&lt;=200)<br>
              <b>Enfermedad avanzada, etapa de SIDA</b> Mayor aumento de riesgo
            </p>
          </div>
          <img class="svg-leyenda" src="@/assets/img/boxplot/boxplot-info.svg" alt="">
        </div>
        <div class="cajas-notas" :class="{open:notas_open_linfocitos}">
          <div class="content">
            <div class="contenedor-notas">
              <p><strong>¿Cómo interpretar un diagrama de caja y bigotes?</strong></p>
              <DaiBoxPlotPresentacion />
            </div>
          </div>
        </div>
        <button aria-hidden="true" class="summary" @click="notas_open_linfocitos=!notas_open_linfocitos" type="button">
          {{notas_open_linfocitos ? "Menos información": "¿Cómo interpretar un diagrama de caja y bigotes?"}}
        </button>
      </template>
    </DaiBoxPlot>
    <PieComponenteLibreria :afuera="true" class="ajuste-footer-boxplot" />
		
	<DaiBoxPlot
      :caja_id="'boxplot-carga-viral'" 
      :datos="datos_boxplot_carga_viral"
      :variables="{'grupos':'Edad_rango','variable_dist':'carga_viral','color':'#4661DE'}"
      :ancho_tooltip="200"
      :margen="margenes_boxplot"
      :alto_vis="alto_vis_barras_apiladas *1.1"
      :textoTooltip="textoTooltipBoxPlotCVEdad"
      :titulo_eje_x="'Rango de edades'"
      :titulo_eje_y="'Carga viral'"
      ref='cajas-carga-viral'
      class="contenedor-barras-apiladas-elaboradas flex-1 ajuste-radius-boxplot"
      :reticula="true"
    >
      <template slot="encabezado">
        <h5 class="titulo-visualizacion">Carga Viral por rango de edad</h5>
        <p class="fecha-actualizacion" >{{fecha_actualizacion}}</p>
		<button type="button" class="boton-modal" @click="$refs.modal_boxplot_cv.abrirModal()">
			Acerca de la gráfica
		</button>
		<modal ref="modal_boxplot_cv" :posicion_boton="'arriba'">
			<template v-slot:cuerpo>
				<p>La siguiente gráfica muestra la distribución de carga viral de VIH de todas las personas que participan en el estudio, por rango de edad. La carga viral nos indica la cantidad de virus que existe en la sangre de una persona. En este caso, los valores de carga viral se midieron en el momento en que las personas se integraron al estudio, el cual muchas veces coincide con su incorporación al seguimiento clínico. Mientras más altos son los valores de carga viral, más posibilidad hay de que se transmita la infección.</p>
			</template>
		</modal>
        <div class="encabezado-leyenda">
          
          <img class="svg-leyenda" src="@/assets/img/boxplot/boxplot-info.svg" alt="">
        </div>
      </template>
      <template slot="pie">
        <div class="pie-leyenda">
          <img class="svg-leyenda" src="@/assets/img/boxplot/boxplot-info.svg" alt="">
        </div>
        <div class="cajas-notas" :class="{open:notas_open_cv}">
          <div class="content">
            <div class="contenedor-notas">
              <p><strong>¿Cómo interpretar un diagrama de caja y bigotes?</strong></p>
              <DaiBoxPlotPresentacion />
            </div>
          </div>
        </div>
        <button aria-hidden="true" class="summary" @click="notas_open_cv=!notas_open_cv" type="button">
          {{notas_open_cv ? "Menos información": "¿Cómo interpretar un diagrama de caja y bigotes?"}}
        </button>
      </template>
    </DaiBoxPlot>
    <PieComponenteLibreria :afuera="true" class="ajuste-footer-boxplot" />
		

		<DaiBarrasApiladas
		:barras_apiladas_id="'bar-distribucion-linfocitos'" 
		:datos="datos_linfocitos"
		:nombre_barra="'linfocitos'"
		:nombre_color="'linfocitos'"
		:variables='[{"id":"cantidad","linfocitos":"Linfocitos","color":"#0695FF"},]'
		:textoTooltip="textoTooltipBarrasDistLinfo"
		:ancho_tooltip="200"
		:alto_vis="alto_vis_barras_apiladas"
		:margen =" margenes_barras_apiladas"
		:titulo_eje_x="'Linfocitos T CD4+ (células/mm³ de sangre)'"
		:titulo_eje_y="'Cantidad de participantes'"
		ref='barras-dist-linfocitos'
		class="contenedor-barras-apiladas-elaboradas flex-1"
		:espaciado_barras="separacion_barras"
		>
      <template slot="encabezado">
        <div class="encabezado">
          <h5 class="titulo-visualizacion">Distribución del conteo de linfocitos T CD4+</h5>
          <p class="fecha-actualizacion" >{{fecha_actualizacion}}</p>
		  <button type="button" class="boton-modal" @click="$refs.modal_distribucion_linfocitos.abrirModal()">
				Acerca de la gráfica
			</button>
			<modal ref="modal_distribucion_linfocitos" :posicion_boton="'arriba'">
				<template v-slot:cuerpo>
					<p>El siguiente histograma muestra la distribución del conteo de linfocitos T CD4+ en todas las personas que han participado en el estudio hasta el momento. El conteo de linfocitos T CD4+ nos indica el estado del sistema inmune, en el momento en que las personas se integran al estudio, el cual muchas veces coincide con su incorporación al seguimiento clínico. Valores por debajo de 200 células/microlitro de sangre indican una infección por VIH avanzada, definida como síndrome de inmunodeficiencia adquirida (SIDA).</p>
				</template>
			</modal>
        </div>
      </template>
      <template slot="pie">
        <div class="pie">
          <PieComponenteLibreria />
        </div>
      </template>
		</DaiBarrasApiladas>

		<DaiBarrasApiladas
		:barras_apiladas_id="'bar-distribucion-cv'" 
		:datos="datos_carga_viral"
		:nombre_barra="'nombre'"
		:nombre_color="'nombre'"
		:variables='[{"id":"cantidad","nombre":"Linfocitos","color":"#B70BFF"},]'
		:textoTooltip="textoTooltipBarrasDistCV"
		:ancho_tooltip="200"
		:alto_vis="alto_vis_barras_apiladas"
		:margen =" margenes_barras_apiladas"
		:titulo_eje_x="'Logaritmo de carga viral de VIH (copias de RNA/mL de plasma)'"
		:titulo_eje_y="'Cantidad de participantes'"
		ref='barras-dist-carga-viral'
		class="contenedor-barras-apiladas-elaboradas flex-1"
		:espaciado_barras="separacion_barras"
		>
      <template slot="encabezado">
        <div class="encabezado">
          <h5 class="titulo-visualizacion">Distribución de la carga viral</h5>
          <p class="fecha-actualizacion" >{{fecha_actualizacion}}</p> 
        </div>
      </template>
      <template slot="pie">
        <div class="pie">
          <PieComponenteLibreria />
        </div>
      </template>
		</DaiBarrasApiladas>
		
		<DaiLineas
		:linea_id="'lineas-arv'" 
		:datos="datos_lineas_arv"
		:nombre_clumna_horizontal="'fecha_toma'"
		:variables_categorias="variables_serie_resistencia"
		:titulo_tooltip="'Tooltip de seleccion'"
		:titulo_eje_y="'Resistencia (%)'"
		:titulo_eje_x="'Fecha'"
		class="contenedor-grafica flex-1"
		:conversionTemporal="conversionTemporal"
		ref="lineas-arv"
		:textoTooltip="textoTooltipLineasARV"
		:margen="margen_lineas_arv"
		>
		<template slot="encabezado">
			<div class="encabezado">
				<h5 class="titulo-visualizacion">Cambio en la proporción de participantes con resistencia a antirretrovirales a través del tiempo</h5>
				<p class="fecha-actualizacion" >{{fecha_actualizacion}}</p>
				<button type="button" class="boton-modal" @click="$refs.modal_cambio_proporcion.abrirModal()">
					Acerca de la gráfica
				</button>
				<modal ref="modal_cambio_proporcion" :posicion_boton="'arriba'">
					<template v-slot:cuerpo>
						<p>La siguiente gráfica muestra los cambios en la proporción de participantes con resistencia a fármacos antirretrovirales que han participado en el estudio a lo largo del tiempo. La resistencia está dividida por familia de fármacos antirretrovirales: INSTI ( inhibidores de la integrasa), NNRTI (inhibidores no nucleósidos de la transcriptasa reversa), NRTI (inhibidores nucleósidos de la transcriptasa reversa), PI (inhibidores de proteasa) o  Compleja (resistencia a más de una familia de fármacos antirretrovirales). Los meses marcados en gris corresponden al periodo de suspensión de actividades del protocolo debido a la contingencia sanitaria por COVID-19.</p>
					</template>
				</modal>
			</div>
		</template>
		<template slot="pie" >
			<div class="pie"> 
				<div class="titulo-switch leyenda-barras-apiladas">
					<div class="titulo-switch">
						<p class="titulo-leyenda">Resistencia a antirretrovirales</p>
						<div class="contenedor-switch">
							<button class="button-left farmaco" :class="{activo: tipo_dato_lineas_arv=='por_farmaco'}" @click="cambioTipoDatoLineasARV('por_farmaco')">
							Clase ARV
							</button>
							<button class="button-right" :class="{activo: tipo_dato_lineas_arv=='general'}" @click="cambioTipoDatoLineasARV('general')">
							General
							</button>
						</div>
					</div>
				</div>
				<div class="nomenclatura">
					<div class="nombre-categoria" v-for="(variable) in variables_serie_resistencia" :key="variable.id">
						<span class="color" v-bind:style="{background: variable.color}"></span>
						<span class="nombre">{{variable.nombre}}</span>
					</div>
					<div class="nombre-categoria suspension" >
						<span class="color" v-bind:style="{background: color_ventana_sarscov2}"></span>
						<span class="nombre">Periodo de suspensión por SARS-CoV-2</span>
					</div>
				</div>
        <PieComponenteLibreria />
			</div>
		</template>
		</DaiLineas>
		
		
		<DaiBarrasApiladas
		:barras_apiladas_id="'bar-apiladas-genero-ss'" 
		:datos="variables_barras_apiladas_genero_ss"
		:nombre_barra="'nombre'"
		:nombre_color="'nombre'"
		:variables='variables_genero_ss'
		:ancho_tooltip="180"
		:alto_vis="alto_vis_barras_apiladas/1.5"
		:margen =" margenes_barras_apiladas_con_nomenclatura"
		:titulo_eje_x ="'Género'"
		:titulo_eje_y ="'Cantidad de participantes'"
		ref='bar-apiladas-genero-ss'
		class="contenedor-barras-apiladas-elaboradas flex-1_2"
		:espaciado_barras="separacion_barras"
		>
		<template slot="encabezado">
			<div class="encabezado">
				<h5 class="titulo-visualizacion">Seguridad social con respecto al género</h5>
				<p class="fecha-actualizacion" >{{fecha_actualizacion}}</p>
			</div>
		</template>
		<template slot="pie" >
			<div class="pie"> 
				<div class="titulo-switch leyenda-barras-apiladas">
					<div class="titulo-switch">
						<p class="titulo-leyenda">Cuenta con seguridad social</p>
						<div class="contenedor-switch">
							<button class="button-left" :class="{activo: tipo_dato_genero_ss=='total'}" @click="cambioTipoDatoGeneroSS('total')">
							Total
							</button>
							<button class="button-right" :class="{activo: tipo_dato_genero_ss=='porcentual'}" @click="cambioTipoDatoGeneroSS('porcentual')">
							Porcentual
							</button>
						</div>
					</div>
				</div>
				<div class="nomenclatura">
					<div class="nombre-categoria" v-for="(variable) in variables_genero_ss" :key="variable.id">
						<span class="color" v-bind:style="{background: variable.color}"></span>
						<span class="nombre">{{variable.nombre}}</span>
					</div>
				</div>
        <PieComponenteLibreria />
			</div>
		</template>
		</DaiBarrasApiladas>

		<DaiViolin
		class="flex-1_2"
		:violin_id="'violinseguridad'"
		:datos="datos_seguridad_social_edad"
		:variables="{'grupos':'seguridad_social','variable_dist':'edad'}"
		:titulo="'Seguridad social con respecto a la edad'"
		:fecha_actualizacion="fecha_actualizacion"
		:bins="20"
		:alto_vis="270"
		:color_violin="'#4167FC'"
		:opacidad_violin=1
		:titulo_eje_y="'Edad'"
		:titulo_eje_x="'Seguridad social'"
		:margen="{arriba: 10, abajo: 90, izquierda: 50, derecha: 20}"
		/>
		
		<DaiBarrasApiladas
		:barras_apiladas_id="'bar-apiladas-genero-resistencia'" 
		:datos="variables_barras_apiladas_genero_resistencia"
		:nombre_barra="'nombre'"
		:nombre_color="'nombre'"
		:variables='variables_genero_resistencia'
		:ancho_tooltip="180"
		:alto_vis="alto_vis_barras_apiladas/1.5"
		:margen =" margenes_barras_apiladas_con_nomenclatura"
		:titulo_eje_x ="'Género'"
		:titulo_eje_y ="'Cantidad de participantes'"
		ref='bar-apiladas-genero-resistencia'
		class="contenedor-barras-apiladas-elaboradas flex-1_2"
		:espaciado_barras="separacion_barras"
		>
		<template slot="encabezado">
			<div class="encabezado">
				<h5 class="titulo-visualizacion">Resistencia a antirretrovirales con respecto al género</h5>
				<p class="fecha-actualizacion" >{{fecha_actualizacion}}</p>
			</div>
		</template>
		<template slot="pie" >
			<div class="pie"> 
				<div class="titulo-switch leyenda-barras-apiladas">
					<div class="titulo-switch">
						<p class="titulo-leyenda">Resistencia a antirretrovirales</p>
						<div class="contenedor-switch">
							<button class="button-left" :class="{activo: tipo_dato_genero_resistencia=='total'}" @click="cambioTipoDatoGeneroResistencia('total')">
							Total
							</button>
							<button class="button-right" :class="{activo: tipo_dato_genero_resistencia=='porcentual'}" @click="cambioTipoDatoGeneroResistencia('porcentual')">
							Porcentual
							</button>
						</div>
					</div>
				</div>
				<div class="nomenclatura">
					<div class="nombre-categoria" v-for="(variable) in variables_genero_resistencia" :key="variable.id">
						<span class="color" v-bind:style="{background: variable.color}"></span>
						<span class="nombre">{{variable.nombre}}</span>
					</div>
				</div>
        <PieComponenteLibreria />
			</div>
		</template>
		</DaiBarrasApiladas>

		<DaiViolin
		class="flex-1_2"
		:violin_id="'violinresistencia'"
		:datos="datos_resistencia_edad"
		:variables="{'grupos':'resistencia','variable_dist':'edad'}"
		:titulo="'Resistencia a antirretrovirales con respecto a la edad'"
		:fecha_actualizacion="fecha_actualizacion"
		:bins="20"
		:alto_vis="270"
		:color_violin="'#4167FC'"
		:opacidad_violin=1
		:titulo_eje_y="'Edad'"
		:titulo_eje_x="'Resistencia'"
		:margen="{arriba: 10, abajo: 85, izquierda: 50, derecha: 20}"
		/>

		
	</div>
</template>
<script>
import DaiViolin from '@/components/graficas/DaiViolin.vue';
import DaiBarrasApiladas from '@/components/graficas/BarrasApiladas.vue';

import DaiBoxPlot from '@/components/graficas/DaiBoxPlot.vue';
import DaiBoxPlotPresentacion from '@/components/graficas/DaiBoxPlotPresentacion.vue';

import data_apilada_resistencia from '@/assets/data/vih_barras_resistencia.json';
import data_apilada_seguridad from '@/assets/data/vih_barras_seguridad.json';

import DaiLineas from '@/components/graficas/DaiLineas.vue';

import * as d3 from "d3";

import PieComponenteLibreria from '@/components/base/PieComponenteLibreria.vue';
import BotonInfoTooltip from "@/components/utils/BotonInfoTooltip.vue";
import Modal from '@/components/base/Modal.vue';

import { mapState } from "vuex";

var lista_meses = [
	"enero",
	"febrero",
	"marzo",
	"abril",
	"mayo",
	"junio",
	"julio",
	"agosto",
	"septiembre",
	"octubre",
	"noviembre",
	"diciembre",
]
var lista_meses_abr = [
	"ene",
	"feb",
	"mar",
	"abr",
	"may",
	"jun",
	"jul",
	"ago",
	"sep",
	"oct",
	"nov",
	"dic",
]

export default {
	name: 'Tablero',
	components: {
		DaiBoxPlot,
    	DaiBoxPlotPresentacion,
		DaiViolin,
		DaiBarrasApiladas,
		DaiLineas,
		PieComponenteLibreria,
		BotonInfoTooltip,
		Modal
	},
	data(){
		return {
			notas_open_linfocitos: false,
			notas_open_cv: false,
			separacion_barras:.1,

			variables_genero_resistencia: [
				{"id":"Con resistencia","nombre":"Con resistencia","color":"#632680"},
				{"id":"Sin resistencia","nombre":"Sin resistencia","color":"#B70BFF"},
			],
			variables_barras_apiladas_genero_resistencia: data_apilada_resistencia,
			datos_carga_viral: [],
			
			datos_linfocitos: [],
			datos_edades: [],
			variables_barras_apiladas_genero_ss: data_apilada_seguridad,
			variables_genero_ss: [
				{"id":"Sin_seguridad","nombre":"No","color":"#000000"},
				{"id":"Con_seguridad","nombre":"Sí","color":"#646464"},
				{"id":"Desconoce","nombre":"No sabe","color":"#632680"},
				{"id":"Sin_informacion","nombre":"Sin dato","color":"#B726FC"},
			],
			diccionario_genero: {
				"F": "Mujer cis",
				"FT": "Mujer trans",
				"M": "Hombre cis",
				"MT": "Hombre trans",
			},
			diccionario_seguridad: {
				"":"Sin información",
				"desconoce":"No sabe",
				"IMSS":"Sí",
				"INSABI":"Sí",
				"ISSSTE":"Sí",
				"Seguro popular":"Sí",
				"sin seguridad social":"No",
				"Otro":"Sí",
				"No Sabe":"No sabe",
				"Seguro Popular":"Sí",
				"otrol":"Sí"
			},
			dict_color_boxplot : {"Sin información": "#B70BFF",
				"Alta": "#B70BFF",
				"Media": "#B70BFF",
				"Baja": "#B70BFF",
			
			},
			datos_boxplot:[],
			datos_boxplot_carga_viral:[],
			datos_resistencia_edad: [],
			datos_seguridad_social_edad: [],
			datos_resistencia_total:[],
			datos_lineas_arv:[],
			datos_resistencia_farmaco:[],
			variables_serie_resistencia:[
				{"cve": "Compleja","nombre": "Compleja","abr":"Compleja","color":"#445DE1","resaltado": false},
				{"cve": "INSTI","nombre": "INSTI","abr":"INSTI","color":"#F8C63D","resaltado": false},
				{"cve": "NNRTI","nombre": "NNRTI","abr":"NNRTI","color":"#FF2112","resaltado": false},
				{"cve": "NRTI","nombre": "NRTI","abr":"NRTI","color":"#E98F41","resaltado": false},
				{"cve": "PI","nombre": "PI","abr":"PI","color":"#A52424","resaltado": false}
			],
			conversionTemporal:d3.timeParse('%Y-%m'),
			margenes_barras_apiladas: {arriba:20,abajo:20,izquierda:30,derecha:20},
			margenes_barras_apiladas_con_nomenclatura: {arriba:20,abajo:20,izquierda:40,derecha:20},
			margen_lineas_arv: {arriba: 10, abajo: 20, izquierda: 30, derecha: 30},
			margenes_boxplot: {arriba:30,abajo:40,izquierda:40,derecha:20},
			alto_vis_barras_apiladas:280,
			tipo_dato_genero_ss:"total",
			tipo_dato_genero_resistencia: "total",
			color_ventana_sarscov2:"#F0F0F0",
			
			tipo_dato_lineas_arv: "por_farmaco"

		}
	},
	mounted(){
		d3.json("data/violin_seguridad_social_edad.json").then((data) => {
			this.datos_seguridad_social_edad = Object.values(data);
		});
		d3.csv("data/violin_resistencia_edad.csv").then((data) => {
			this.datos_resistencia_edad = data;
		});
		d3.csv("data/vih_barras_edades.csv").then((data) => {
			this.datos_edades = data;
		});
		d3.csv("data/vih_barras_simples_linfocitos.csv").then((data) => {
			this.datos_linfocitos = data;
		});
		d3.csv("data/vih_barras_simples_carga_viral.csv").then((data) => {
			this.datos_carga_viral = data;
		});
		d3.json('data/vih_bigotes_cd4.json').then((data) => {
			this.datos_boxplot = data.map(d=> ({"Edad_rango" :(d.edad_rango!=""?d.edad_rango: "Sin información" ),"CD4_A" : +d.cd4_a})).sort((a,b) => d3.ascending(a.Edad_rango,b.Edad_rango));
			this.agregarFondoBoxplot("cajas-linfocitos")
		})
		d3.json('data/vih_bigotes_carga_viral.json').then((data) => {
			this.datos_boxplot_carga_viral = data.map(d=> ({"Edad_rango" :(d.edad_rango!=""?d.edad_rango: "Sin información" ),"carga_viral" : +d.cv})).sort((a,b) => d3.ascending(a.Edad_rango,b.Edad_rango));
		})
		d3.csv('data/resistencia_por_ARV_contra_tiempo_pivot.csv').then((data) => {
			data.forEach((d)=>{
				d.Compleja=+d.Compleja,
				d.INSTI=+d.INSTI,
				d.NNRTI=+d.NNRTI,
				d.NRTI=+d.NRTI,
				d.PI=+d.PI
			})
			this.datos_resistencia_farmaco = data;
			this.datos_lineas_arv = data;
			this.agregarRectanguloLineas("lineas-arv")
		})
		d3.csv('data/resistencia_contra_tiempo.csv').then((data) => {
			data.forEach((d)=>{
				d.pacientes_con_resistencia=+d.pacientes_con_resistencia
				d.total = +d.total;
				d.porcentaje = +d.porcentaje
			})
			this.datos_resistencia_total = data;
		})
		
		window.addEventListener("resize", this.reescalandoPantalla);
		this.reescalandoPantalla()
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.reescalandoPantalla);

	},
	watch:{
		datos_resistencia(){
			this.agregarRectanguloLineas("lineas-arv")
		}
	},
  methods:{
    // Barras simples
    
    textoTooltipBarrasDistCV(){
      let porcentaje =100 * this.$refs['barras-dist-carga-viral'].tooltip_data_seleccionada["cantidad"] / d3.sum(this.datos_carga_viral.map((d) => +d.cantidad));
      return `<p>
        <b>${this.$refs['barras-dist-carga-viral'].tooltip_data_seleccionada["cantidad"].toLocaleString("en")}
          (${porcentaje.toLocaleString("en")}%)
        </b> participantes con 
        log(${this.$refs['barras-dist-carga-viral'].tooltip_data_seleccionada["nombre"] }) de carga viral de VIH (copias de RNA/mL de plasma)`
    },
    textoTooltipBarrasDistLinfo(){
      let porcentaje =100 * this.$refs['barras-dist-linfocitos'].tooltip_data_seleccionada["cantidad"] / d3.sum(this.datos_carga_viral.map((d) => +d.cantidad));
      return `<p>
        <b>${this.$refs['barras-dist-linfocitos'].tooltip_data_seleccionada["cantidad"].toLocaleString("en")}
          (${porcentaje.toLocaleString("en")}%)
        </b> participantes con 
        ${this.$refs['barras-dist-linfocitos'].tooltip_data_seleccionada["nombre"]} de conteo de linfocitos T CD4+ (células/mm³ de sangre)`
    },
	textoTooltipBoxPlotLinfoEdad(){
		return  `
			<p class="titulo-tooltip"><b>Rango de edad</b>: ${this.$refs["cajas-linfocitos"].tooltip_categoria}</p>
			<div class="row-tooltip">
				<div class="col-tooltip-1">
					<img src="${
						require("@/assets/img/boxplot-tooltip.png")
					}"/>
				</div>
				<div class="col-tooltip-2">
					<p>Bigote sup.: ${this.$refs["cajas-linfocitos"].tooltip_data_seleccionada?.max?.toLocaleString("en")}</p>
					<p>3er cuartil: ${this.$refs["cajas-linfocitos"].tooltip_data_seleccionada.q3.toLocaleString("en")}</p>
					<p>Promedio: ${this.$refs["cajas-linfocitos"].tooltip_data_seleccionada.promedio.toLocaleString("en")}</p>
					<p>Mediana ${this.$refs["cajas-linfocitos"].tooltip_data_seleccionada.median.toLocaleString("en")}</p>
					<p>1er cuartil: ${this.$refs["cajas-linfocitos"].tooltip_data_seleccionada.q1.toLocaleString("en")}</p>
					<p>Bigote inf.: ${this.$refs["cajas-linfocitos"].tooltip_data_seleccionada.min.toLocaleString("en")}</p>
				</div>
			</div>
			
		`
	},
	textoTooltipBoxPlotCVEdad(){
		return  `
			<p class="titulo-tooltip"><b>Rango de edad</b>: ${this.$refs["cajas-carga-viral"].tooltip_categoria}</p>
			<div class="row-tooltip">
				<div class="col-tooltip-1">
					<img src="${
						require("@/assets/img/boxplot-tooltip.png")
					}"/>
				</div>
				<div class="col-tooltip-2">
					<p>Bigote sup: ${this.$refs["cajas-carga-viral"].tooltip_data_seleccionada.max?.toLocaleString("en")}</p>
					<p>3er cuartil: ${this.$refs["cajas-carga-viral"].tooltip_data_seleccionada.q3.toLocaleString("en")}</p>
					<p>Promedio: ${this.$refs["cajas-carga-viral"].tooltip_data_seleccionada.promedio.toLocaleString("en")}</p>
					<p>Mediana ${this.$refs["cajas-carga-viral"].tooltip_data_seleccionada.median.toLocaleString("en")}</p>
					<p>1er cuartil: ${this.$refs["cajas-carga-viral"].tooltip_data_seleccionada.q1.toLocaleString("en")}</p>
					<p>Bigote inf: ${this.$refs["cajas-carga-viral"].tooltip_data_seleccionada.min.toLocaleString("en")}</p>
				</div>
			</div>
			
		`
	},
    // Apiladas apiladas
    cambioTipoDatoGeneroSS(nv){
		this.tipo_dato_genero_ss = nv;
		if(this.tipo_dato_genero_ss == "total"){
			this.variables_barras_apiladas_genero_ss = data_apilada_seguridad
		}
		else{
			this.variables_barras_apiladas_genero_ss = data_apilada_seguridad.map((d) => {
				let dic = {}
				this.variables_genero_ss.map((dd) => {
					dic[dd.id] = 100 * d[dd.id]/d3.sum(this.variables_genero_ss.map(dd=>d[dd.id]))
				})
			dic["nombre"] = d.nombre;
			return dic
		});
		setTimeout(()=>
			this.$refs["bar-apiladas-genero-ss"].eje_y.selectAll("text").text((d) =>d + "%")
			,100)
		}
    },
    cambioTipoDatoGeneroResistencia(nv){
		this.tipo_dato_genero_resistencia = nv;
		if(this.tipo_dato_genero_resistencia == "total"){
			this.variables_barras_apiladas_genero_resistencia = data_apilada_resistencia
		}
		else{
			this.variables_barras_apiladas_genero_resistencia = data_apilada_resistencia.map((d) => {
				let dic = {}
				this.variables_genero_resistencia.map((dd) => {
					dic[dd.id] = 100 * d[dd.id]/d3.sum(this.variables_genero_resistencia.map(dd=>d[dd.id]))
				})
				dic["nombre"] = d.nombre;
				return dic
		});
		setTimeout(()=>
			this.$refs["bar-apiladas-genero-resistencia"].eje_y.selectAll("text").text((d) =>d + "%")
			,100)
		}
    },

    //Lineas 
    agregarRectanguloLineas(grafica_ref){
		setTimeout(()=>{
			this.$refs[grafica_ref]?.grupo_frente
				.select("rect.ventana-temporal").remove()
			this.$refs[grafica_ref]?.grupo_frente
				.append("rect")
				.attr("class","ventana-temporal")
				.style("fill",this.color_ventana_sarscov2)
				.attr("x",this.$refs[grafica_ref]?.escalaX(this.$refs[grafica_ref].conversionTemporal("2020-03"))? this.$refs[grafica_ref].escalaX(this.$refs[grafica_ref].conversionTemporal("2020-03")) : 0)
				.attr("y",0)
				.attr("width",this.$refs[grafica_ref].escalaX(3)?this.$refs[grafica_ref].escalaX(this.$refs[grafica_ref].conversionTemporal("2020-07"))
				-this.$refs[grafica_ref].escalaX(this.$refs[grafica_ref].conversionTemporal("2020-03")):0)
				.attr("height",this.$refs[grafica_ref].height)
			
			
		},300)
    },
	
	agregarFondoBoxplot(grafica_ref){
		setTimeout(()=>{
			//Agregué también un translate al grupo_fondo dentro del componente de boxplot para empatarlo con el grupo_contenedor de cajas
			//removiendo todos los fondos que pudieran existir, esto sirve cuando reescalamos y ya se crearon anteriormente
			this.$refs[grafica_ref]
				?.grupo_fondo.selectAll("rect.fondos").remove()
			//Agregando fondo normal
			this.$refs[grafica_ref]
				?.grupo_fondo
				.append("rect")
				.attr("class","fondos")
				.style("fill","#9ad0fc")
				.attr("x",0)
				.attr("y",0)
				.attr("width",this.$refs[grafica_ref]?.width ? this.$refs[grafica_ref]?.width : 0)
				.attr("height",this.$refs[grafica_ref]?.escalaY(200)  ? this.$refs[grafica_ref].escalaY(500): 0)
			//Agregando fondo intermedio
			this.$refs[grafica_ref]
				?.grupo_fondo
				.append("rect")
				.attr("class","fondos")
				.style("fill","#C5E5FE")
				.attr("x",0)
				.attr("y",this.$refs[grafica_ref]?.escalaY(500) ? this.$refs[grafica_ref]?.escalaY(500) : 0)
				.attr("width",this.$refs[grafica_ref]?.width ? this.$refs[grafica_ref]?.width : 0)
				.attr("height",this.$refs[grafica_ref]?.escalaY(500)  ? this.$refs[grafica_ref].escalaY(200) - this.$refs[grafica_ref].escalaY(500) :0)
			//Agregando fondo bajo
			this.$refs[grafica_ref]
				?.grupo_fondo
				.append("rect")
				.attr("class","fondos")
				.style("fill","#E7F4FF")
				.attr("x",0)
				.attr("y",this.$refs[grafica_ref]?.escalaY(200) ? this.$refs[grafica_ref]?.escalaY(200) : 0)
				.attr("width",this.$refs[grafica_ref]?.width ? this.$refs[grafica_ref]?.width : 0)
				.attr("height",this.$refs[grafica_ref]?.escalaY(200)  ? this.$refs[grafica_ref].escalaY(0) - this.$refs[grafica_ref].escalaY(200) :0)
		}, 200)
	},

    textoTooltipLineasARV(){
		if(this.tipo_dato_lineas_arv == "por_farmaco"){
			let total_muestras = d3.sum(this.$refs["lineas-arv"].variables_categorias.map((d) => this.$refs["lineas-arv"].tooltip_data_seleccionada[d.cve]));
			let cifras_variables = this.$refs["lineas-arv"].variables_categorias.map((d) => `<li>
				<span class="span-tooltip-color" style="background: ${d.color} "></span>
				${d.cve} <b>${( this.$refs["lineas-arv"].tooltip_data_seleccionada[d.cve]).toLocaleString("en")}</b>
				(${Math.round(100 * this.$refs["lineas-arv"].tooltip_data_seleccionada[d.cve]/total_muestras)}%)
				</li>`)
			return `
			<p><b>Porcentaje de participantes con resistencia ARV</b></p>
			<p>
				Fecha: ${lista_meses[this.$refs["lineas-arv"].tooltip_data_seleccionada.fech.getMonth()]} / ${this.$refs["lineas-arv"].tooltip_data_seleccionada.fech.getFullYear()}
			</p>
			<ul class="tooltip-lineas">${cifras_variables.join("")}</ul>`
		}else if(this.tipo_dato_lineas_arv == "general"){
			let cifras_variables = this.$refs["lineas-arv"].variables_categorias.map((d) => `<li>
				<span class="span-tooltip-color" style="background: ${d.color} "></span>
				${d.cve} <b>${( this.$refs["lineas-arv"].tooltip_data_seleccionada[d.cve]).toLocaleString("en")}</b>
				(${this.$refs["lineas-arv"].tooltip_data_seleccionada.porcentaje}%)
				</li>`)
			return `
			<p><b>Porcentaje de participantes con resistencia ARV</b></p>
			<p>
				Fecha: ${lista_meses[this.$refs["lineas-arv"].tooltip_data_seleccionada.fech.getMonth()]} / ${this.$refs["lineas-arv"].tooltip_data_seleccionada.fech.getFullYear()}
			</p>
			<ul class="tooltip-lineas">${cifras_variables.join("")}</ul>`
		}
        
    },
	cambioTipoDatoLineasARV(nv){
		this.tipo_dato_lineas_arv = nv
		if(nv == "por_farmaco"){
			this.variables_serie_resistencia =[
				{"cve": "Compleja","nombre": "Compleja","abr":"Compleja","color":"#445DE1","resaltado": false},
				{"cve": "INSTI","nombre": "INSTI","abr":"INSTI","color":"#F8C63D","resaltado": false},
				{"cve": "NNRTI","nombre": "NNRTI","abr":"NNRTI","color":"#FF2112","resaltado": false},
				{"cve": "NRTI","nombre": "NRTI","abr":"NRTI","color":"#E98F41","resaltado": false},
				{"cve": "PI","nombre": "PI","abr":"PI","color":"#A52424","resaltado": false}
			];
			this.datos_lineas_arv = this.datos_resistencia_farmaco
		}
		else if(nv == "general"){
			this.variables_serie_resistencia =[
				{"cve": "total","nombre": "Total","abr":"total","color":"#B726FC","resaltado": false}];
			this.datos_lineas_arv = this.datos_resistencia_total
		}
		this.agregarRectanguloLineas("lineas-arv")

	},

	//Reescalado

    reescalandoPantalla(){
		this.agregarRectanguloLineas("lineas-arv")
		this.agregarFondoBoxplot("cajas-linfocitos")
		if(window.innerWidth < 450){
			this.margen_lineas_arv =  {arriba: 10, abajo: 50, izquierda: 30, derecha: 30}
			this.alto_vis_barras_apiladas = 300
			this.margenes_barras_apiladas = {arriba:20,abajo:50,izquierda:40,derecha:20};
			this.margenes_barras_apiladas_con_nomenclatura = {arriba:20,abajo:70,izquierda:40,derecha:20}

			setTimeout(()=>{
				this.$refs["barras-dist-linfocitos"].eje_x.selectAll("text").attr("transform","rotate(-50)translate(-10,-5)").style("text-anchor","end");
				this.$refs["barras-dist-carga-viral"].eje_x.selectAll("text").attr("transform","rotate(-50)translate(-10,-5)").style("text-anchor","end");
				//this.$refs["barras-carga-viral"].eje_x.selectAll("text").attr("transform","rotate(-50)translate(-10,-5)").style("text-anchor","end");
				//this.$refs["barras-linfocitos"].eje_x.selectAll("text").attr("transform","rotate(-50)translate(-10,-5)").style("text-anchor","end");
				this.$refs["bar-apiladas-genero-ss"].eje_x.selectAll("text").attr("transform","rotate(-50)translate(-10,-5)").style("text-anchor","end");
				this.$refs["bar-apiladas-genero-resistencia"].eje_x.selectAll("text").attr("transform","rotate(-50)translate(-10,-5)").style("text-anchor","end");
				this.$refs["lineas-arv"].eje_x.selectAll("text").attr("transform","rotate(-50)translate(-6,-12)").style("text-anchor","end");

			},200)	
		
		}
		else{
			this.alto_vis_barras_apiladas = 300
			this.margen_lineas_arv =  {arriba: 10, abajo: 20, izquierda: 30, derecha: 30}

			this.margenes_barras_apiladas = {arriba:20,abajo:20,izquierda:40,derecha:20}
			this.margenes_barras_apiladas_con_nomenclatura = {arriba:20,abajo:20,izquierda:40,derecha:20}
			this.margenes_boxplot = {arriba:30,abajo:40,izquierda:40,derecha:20}
			setTimeout(()=>{
				this.$refs["barras-dist-linfocitos"]?.eje_x.selectAll("text").attr("transform","rotate(0)").style("text-anchor","middle")
				this.$refs["barras-dist-carga-viral"]?.eje_x.selectAll("text").attr("transform","rotate(0)").style("text-anchor","middle")
				//this.$refs["barras-carga-viral"].eje_x.selectAll("text").attr("transform","rotate(0)").style("text-anchor","middle")
				// this.$refs["barras-linfocitos"].eje_x.selectAll("text").attr("transform","rotate(0)").style("text-anchor","middle")
				this.$refs["bar-apiladas-genero-ss"]?.eje_x.selectAll("text").attr("transform","rotate(0)").style("text-anchor","middle")
				this.$refs["bar-apiladas-genero-resistencia"]?.eje_x.selectAll("text").attr("transform","rotate(0)").style("text-anchor","middle")
				this.$refs["lineas-arv"]?.eje_x.selectAll("text").attr("transform","rotate(0)").style("text-anchor","middle");
				},200)
			}
			if(document.querySelector("div#boxplot1 div.contenedor-tooltip-svg")?.clientWidth < 450){
				this.margenes_boxplot = {arriba:30,abajo:80,izquierda:40,derecha:20}
				setTimeout(()=>{
					
					this.$refs["cajas-linfocitos"]?.eje_x.selectAll("text").style("text-anchor","end")
						.attr("transform","rotate(-50)translate(-6,-12)")
					this.$refs["cajas-carga-viral"]?.eje_x.selectAll("text").style("text-anchor","end")
						.attr("transform","rotate(-50)translate(-6,-12)")
					
					},250)

			}
			else{
				this.margenes_boxplot = {arriba:30,abajo:40,izquierda:40,derecha:20};
				setTimeout(()=>{
					this.$refs["cajas-linfocitos"]?.eje_x.selectAll("text").attr("transform","rotate(0)").style("text-anchor","middle")
					this.$refs["cajas-carga-viral"]?.eje_x.selectAll("text").attr("transform","rotate(0)").style("text-anchor","middle")
					
				},200)
			}
    }
  },
	computed: {
    ...mapState({
			fecha_actualizacion: state => `Última Actualización: ${state['fechaActualizacion']}`
		}),
  },
}

</script>

<style lang="scss">
  .tablero-flex {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .flex-1,
    .flex-1_2 {
      flex: 1 0 100%;
      max-width: 100%;
      margin-bottom: $gap*.65;
    }
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      .flex-1 {
        margin-bottom: $gap;
      }
      .flex-1_2 {
        flex: 1 0 calc(50% - #{$gap*.5});
        max-width: calc(50% - #{$gap*.5});
        margin-bottom: $gap;
      }
    }
  }
  .container-boxplot {
    border: 1px solid #333;
    border-radius: 10px;
    overflow: hidden;
    width: 100%;
    text-align: center;
    img {
      width: 100%;
    }
  }

  div#boxplot1, div#boxplot-carga-viral{
	  #carrusel_boxplot div.contenedor-boxplot-carrusel{
		  margin: 10px auto;
		  max-width: 900px;
		  font-size: 14px;;
		  display: flex;
		  flex-wrap: nowrap;
		  div{
			  width: 50%;
			  max-height: 190px;
			  &.carrusel-div-txt{
				  max-width: 350px;
				  margin: auto
			  }
			  img{
				  width: 100%;
				  max-width:350px
			  }
		  }
		  div.txt-tercios{
			  width: 33%;
			  p.descripcion{
				  color: #707070;
			  }
			  p span{
				  font-weight: 300;
			  }
			  p.bajo {
				  padding-left: 10px;
					border-left: solid 18px #E7F4FF;
				}
				p.intermedio {
					padding-left: 10px;
					border-left: solid 18px #C5E5FE;
				}
				p.normal {
					padding-left: 10px;
					border-left: solid 18px #9ad0fc;
	  		}
		  }
	  }
  }
	div#boxplot1, div#boxplot-carga-viral{
		div.tooltip{
			div.row-tooltip{
				display: flex;
				flex-wrap: nowrap;
				div.col-tooltip-1{
					width: 35%;
					img{
					max-height: 140px;
					}
				}
				div.col-tooltip-2{
					p{
						margin: 2px 0 8px 0;
					}
				}
			}
			
			p{
				font-size:12px
			}
			p.titulo-tooltip{
				font-size:14px;
				margin-bottom:10px;
			}
		}
	}
  div#lineas-arv {
    div.tooltip{
      div.tooltip-cuerpo{
      font-size: 12px;
        p{
          margin: 0;
        }
        ul.tooltip-lineas{
          margin: 0;
          padding: 5px 0 0 0;
          li{
            list-style: none;
            margin: 0 0 5px 0;
            font-size: 12px;
            &::before {
              background: transparent;
            }
            span.span-tooltip-color {
              transform: translateY(2px);
              width: 12px;
              height: 12px;
              border: solid 1px rgba(255, 255, 255, .7 );
              display: inline-block;
              border-radius: 50%;
            }
          }
        }
      }
    }
    
  }
  div.contenedor-grafica, div.contenedor-barras-apiladas-elaboradas {
    width: 100%;
    border: solid black 1px;
    border-radius: 10px;
    position: relative;
    
    .titulo-proyecto {
      font-size: 12px;
    }

    .encabezado {
      padding: 10px;
      .titulo-visualizacion {
        font-size: 16px;
        font-weight: 500;
        margin: 0;
      }
      .fecha-actualizacion {
        font-size: 12px;
        margin: 5px 0;
      }
      .instruccional {
        font-size: 12px;
        margin: 5px 0;
      }
    }


    .titulo-leyenda {
      font-size: 16px;
      font-weight: 500;
      margin: 10px 0 0;
    }
    .texto-leyenda {
      font-size: 14px;
    }
    .texto-leyenda-notas {
      font-size: 12px;
    }
    .flex-leyenda {
      display: flex;
      align-items: center;
      > p {
        margin: 10px 0;
      }
    }
    .cuadro-leyenda {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    .svg-leyenda {
      border-top: 1px solid #ccc;
      padding-top: 16px;
      width: 100%;
    }
    .color-1 {
      background-color:#E7F4FF;
    }
    .color-2 {
      background-color: #C5E5FE;
      margin-left: 16px;
    }
    .color-3 {
      background-color: #9ad0fc;
      margin-left: 16px;
    }

    .encabezado-leyenda {
      display: none;
    }
    .pie-leyenda {
      display: block;
      box-shadow: 0 -2px 10px rgba(0,0,0,.2);
      border-radius: 10px 10px 0 0;
      padding: 10px 20px;
    }
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      .encabezado-leyenda {
        border-top: 1px solid #ccc;
        margin-top: 10px;
        display: block;
      }
      .pie-leyenda {
        display: none;
      }
    }
	div.pie{
		// estilo caja mayor información
		$border-radius-tarjeta:10px;
		width: 100%;
		.summary {
			
				// height: 30px;
				background:#000;
				color: #fff;
				text-align: center;
				font-size: 12px;
        line-height: 1.2em;
				font-weight: 500;
				padding: 4px;
				width: 100%;
				border: solid 1px #000;
				border-radius:0 0 $border-radius-tarjeta $border-radius-tarjeta;
				transition: all .27s ease-in-out;
				&:hover,
				&:focus,
				&:active {
					background-color: #000;
					color: #fff;
				}
			}
		.cajas-notas {
			color: #222;
			
			.content {
				overflow: hidden;
				transition: all .33s ease-in-out;
				padding: 0 15px;
				margin-bottom: 10px;
				font-size: 12px;
				line-height: 1.3em;
			}
			height:0;
			overflow: hidden;
			&.open {
				height: auto;
				.content{
					padding: 5px 15px;
				}
				
			}
		}
		.cajas-notas {
			.content {
        border-top: solid 1px #000;
				font-size: 14px;
			}
		}
	}
    div.nomenclatura{
      margin-top: 15px;
      margin-bottom:10px;
      display: flex;
	  flex-wrap: wrap;
      
      justify-content: flex-start;
      div.nombre-categoria{
        margin: 0;
        padding: 5px 10px;
        display: flex;
        .color{
          border-radius: 50%;
          width: 20px;
          min-width: 20px;
          height: 20px;
        }
        .nombre {
          font-size: 12px;
          line-height: 1.6;
          padding-left: 10px;
        }
		&.suspension{
			.color{
				border-radius: 0; 
				border: 1px solid #707070;
			}
		}
      }
    }
    div.leyenda-barras-apiladas{
		
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: nowrap;
      border-radius: 15px;
      box-shadow: 0px -5px 5px -1px rgb(221, 221, 221);
      margin-bottom:10px;
      div.titulo-switch{
      display: flex;
      width: 100%;
      p.titulo-leyenda{
			width: 100%;
			margin-bottom: 5px;
			text-align: center;
			font-size: 12px;
			font-weight: 700;
		}
      div.contenedor-switch{
        display: inline-flex;
        margin: 10px  20px 0 0;
        box-shadow: 0px 3px 6px #00000029;
		max-height: 24px;

        button{
          font-size: 12px;
          margin: 0px;
          &.button-right{
            border-radius:  0 3px 3px 0;
          }
          &.button-left{
            border-radius:  3px 0 0 3px;
			&.farmaco{
				width:90px;
			}
          }
          &.activo {
            background: #FFFFFF;
            color: #141414;
            text-decoration: none;
          }
        }
      }
    }
    }	
}
svg.svg-violines .titulo-eje {
	font-weight: 600;
}
.ajuste-radius-boxplot {
  border-radius: 10px 10px 0 0 !important;
  button.summary {
    border-radius: 0!important;
  }
  
}
.ajuste-footer-boxplot {
  margin-top: -10px;
  margin-bottom: 10px;
  @media (min-width: map-get($media-queries-limit, "mobile")) {
    margin-top: -20px;
    margin-bottom: 20px;
  }
}
</style>
